import { createFileRoute } from '@tanstack/react-router';
import { msg } from '@lingui/core/macro';
import { BatteryCharging } from 'lucide-react';
import { Trans } from '@lingui/react/macro';
import { useCurrentUser } from '@/hooks/queries/auth.ts';
import { PageContainer } from '@/components/page-container.tsx';
import { FeatureLockedPage } from '@/components/feature-locked.tsx';
import { ChargeMapCard } from './+components/chargemap-card.tsx';

export const Route = createFileRoute('/_logged/chargemap/')({
  component: ChargeMapRoute,
  staticData: { label: msg`ChargeMap` },
});

function ChargeMapRoute() {
  const user = useCurrentUser();
  const enabled = user.features.parkadmin?.cmb_feature ?? false;
  return enabled ?
      <ChargeMapPage />
    : <FeatureLockedPage
        feature='ChargeMap Business'
        icon={BatteryCharging}
        title={
          <Trans comment="Title of the full-page teaser shown instead of the ChargeMap page when the customer's software does not include the ChargeMap Business feature.">
            ChargeMap Business is not enabled
          </Trans>
        }
        description={
          <Trans comment="Description under the teaser title, explaining the ChargeMap Business feature is missing from the customer's software and inviting them to upgrade. 'ChargeMap Business' is a product name, keep untranslated.">
            Your software does not include the ChargeMap Business feature. Upgrade it to enable it.
          </Trans>
        }
      />;
}

function ChargeMapPage() {
  return (
    <PageContainer>
      <ChargeMapCard />
    </PageContainer>
  );
}
